/**
 * 用户关联
 * **/

const userProjectsApi = {
  //获取列表
  getList: '/SysUserProjects/GetList',
  //添加
  add: '/SysUserProjects/Add',
  //删除
  delete: '/SysUserProjects/Del',
}

export default userProjectsApi
